/* import __COLOCATED_TEMPLATE__ from './sub-nav.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

class SubNavComponent extends Component {
  get classNames() {
    return clsx('subnav-wrapper', {
      subnav: !this.args.sticky,
      'subnav-sticky': this.args.sticky,
    });
  }

  get subNav() {
    return this.args.use;
  }

  get hasDataAttributes() {
    return !!(Object.values(this.args.subNavModel)[0]?.dataRef);
  }
}

export default SubNavComponent;
